import { Dispatch } from "react";
import { GETAPI, POSTAPI, PATCHAPI } from "../../API/Api";
import { ApiConfig } from "../../Config/CommonConfig";
import {
  CREATE_COUPON_FAIL,
  CREATE_COUPON_REQUEST,
  CREATE_COUPON_SUCCESS,
  CREATE_MANUAL_CREDIT_GRANT_FAIL,
  CREATE_MANUAL_CREDIT_GRANT_REQUEST,
  CREATE_MANUAL_CREDIT_GRANT_SUCCESS,
  GET_ENTITY_TRANSACTIONS_REQUEST,
  GET_ENTITY_TRANSACTIONS_SUCCESS,
  GET_ENTITY_TRANSACTIONS_FAIL,
  CREATE_PAYMENT_PLAN_FAIL,
  CREATE_PAYMENT_PLAN_REQUEST,
  CREATE_PAYMENT_PLAN_SUCCESS,
  CREATE_PLAN_DISCOUNT_FAIL,
  CREATE_PLAN_DISCOUNT_REQUEST,
  CREATE_PLAN_DISCOUNT_SUCCESS,
  CREATE_PROMO_CODE_FAIL,
  CREATE_PROMO_CODE_REQUEST,
  CREATE_PROMO_CODE_SUCCESS,
  CREATE_SERVICE_CHARGE_FAIL,
  CREATE_SERVICE_CHARGE_REQUEST,
  CREATE_SERVICE_CHARGE_SUCCESS,
  GET_COUPON_LIST_FAIL,
  GET_COUPON_LIST_REQUEST,
  GET_COUPON_LIST_SUCCESS,
  GET_COUPON_USAGE_LIST_FAIL,
  GET_COUPON_USAGE_LIST_REQUEST,
  GET_COUPON_USAGE_LIST_SUCCESS,
  GET_DLQ_MESSAGES_LIST_FAIL,
  GET_DLQ_MESSAGES_LIST_REQUEST,
  GET_DLQ_MESSAGES_LIST_SUCCESS,
  GET_PAYMENT_PLANS_LIST_FAIL,
  GET_PAYMENT_PLANS_LIST_REQUEST,
  GET_PAYMENT_PLANS_LIST_SUCCESS,
  GET_PAYMENT_PLAN_DETAIL_FAIL,
  GET_PAYMENT_PLAN_DETAIL_REQUEST,
  GET_PAYMENT_PLAN_DETAIL_SUCCESS,
  GET_PROMO_CODE_LIST_FAIL,
  GET_PROMO_CODE_LIST_REQUEST,
  GET_PROMO_CODE_LIST_SUCCESS,
  GET_PROMO_USAGE_LIST_FAIL,
  GET_PROMO_USAGE_LIST_REQUEST,
  GET_PROMO_USAGE_LIST_SUCCESS,
  GET_SERVICE_CHARGE_LIST_FAIL,
  GET_SERVICE_CHARGE_LIST_REQUEST,
  GET_SERVICE_CHARGE_LIST_SUCCESS,
  UPDATE_COUPON_FAIL,
  UPDATE_COUPON_REQUEST,
  UPDATE_COUPON_SUCCESS,
  UPDATE_PAYMENT_PLAN_DISCOUNT_FAIL,
  UPDATE_PAYMENT_PLAN_DISCOUNT_REQUEST,
  UPDATE_PAYMENT_PLAN_DISCOUNT_SUCCESS,
  UPDATE_PAYMENT_PLAN_FAIL,
  UPDATE_PAYMENT_PLAN_REQUEST,
  UPDATE_PAYMENT_PLAN_SUCCESS,
  UPDATE_PROMO_FAIL,
  UPDATE_PROMO_REQUEST,
  UPDATE_PROMO_SUCCESS,
} from "../../Constants/PaymentConstants";

export const PaymentPlanListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_PAYMENT_PLANS_LIST_REQUEST });
 
      let data = await GETAPI(ApiConfig?.PaymentPlansList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_PAYMENT_PLANS_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_PAYMENT_PLANS_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const PaymentPlanCreateAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_PAYMENT_PLAN_REQUEST });
      let data = await POSTAPI(ApiConfig?.PaymentPlanCreate, payload);
      if (data && data.status === true) {
        dispatch({
          type: CREATE_PAYMENT_PLAN_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: CREATE_PAYMENT_PLAN_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const PromoCodeListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_PROMO_CODE_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.PromoCodeList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_PROMO_CODE_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_PROMO_CODE_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const PromoCodeCreateAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_PROMO_CODE_REQUEST });
      const isEvaluation =
        payload?.category && payload?.category?.toUpperCase() === "EVALUATION";
      const createUrl = isEvaluation
        ? ApiConfig?.EvaluationPromoCodeCreate
        : ApiConfig?.PromoCodeCreate;

      let data = await POSTAPI(createUrl, payload);
      if (data && data.status === true) {
        dispatch({
          type: CREATE_PROMO_CODE_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: CREATE_PROMO_CODE_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const ServiceChargeListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_SERVICE_CHARGE_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.ServiceChargeList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_SERVICE_CHARGE_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_SERVICE_CHARGE_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const ServiceChargeCreateAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_SERVICE_CHARGE_REQUEST });
      let data = await POSTAPI(ApiConfig?.ServiceChargeCreate, payload, true);
      if (data && data.status === true) {
        dispatch({
          type: CREATE_SERVICE_CHARGE_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: CREATE_SERVICE_CHARGE_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const DLQMessageListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_DLQ_MESSAGES_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.DLQMessagesList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_DLQ_MESSAGES_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_DLQ_MESSAGES_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const PromoUsageListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_PROMO_USAGE_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.PromoUsageList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_PROMO_USAGE_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_PROMO_USAGE_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const PromoUpdateAction =
  (payload: any, params: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPDATE_PROMO_REQUEST });

      const isEvaluation =
        payload?.category &&
        String(payload?.category).toUpperCase() === "EVALUATION";
      const updateUrl = isEvaluation
        ? ApiConfig?.EvaluationPromoCodeUpdate
        : ApiConfig?.PromoCodeUpdate;

      let data = await PATCHAPI(updateUrl + params, payload, true);

      if (data && data.status === true) {
        dispatch({
          type: UPDATE_PROMO_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: UPDATE_PROMO_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const CouponListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_COUPON_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.CouponList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_COUPON_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_COUPON_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const CouponUsageListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_COUPON_USAGE_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.CouponUsageList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_COUPON_USAGE_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_COUPON_USAGE_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const CouponCreateAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_COUPON_REQUEST });
      let data = await POSTAPI(ApiConfig?.CouponCreate, payload, true);
      if (data && data.status === true) {
        dispatch({
          type: CREATE_COUPON_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: CREATE_COUPON_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const CouponUpdateAction =
  (payload: any, params: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPDATE_COUPON_REQUEST });

      let data = await PATCHAPI(
        ApiConfig?.CouponUpdate + params,
        payload,
        true
      );

      if (data && data.status === true) {
        dispatch({
          type: UPDATE_COUPON_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: UPDATE_COUPON_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const FetchPlanDetailAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_PAYMENT_PLAN_DETAIL_REQUEST });

      let data = await GETAPI(ApiConfig?.PaymentPlanDetail + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_PAYMENT_PLAN_DETAIL_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_PAYMENT_PLAN_DETAIL_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const UpdatePlanAction =
  (payload: any, params: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPDATE_PAYMENT_PLAN_REQUEST });

      let data = await PATCHAPI(
        ApiConfig?.PaymentPlanUpdate + params,
        payload,
        true
      );

      if (data && data.status === true) {
        dispatch({
          type: UPDATE_PAYMENT_PLAN_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: UPDATE_PAYMENT_PLAN_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const PaymentPlanCreateDiscountAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_PLAN_DISCOUNT_REQUEST });
      let data = await POSTAPI(ApiConfig?.PlanDiscountCreate, payload, true);
      if (data && data.status === true) {
        dispatch({
          type: CREATE_PLAN_DISCOUNT_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: CREATE_PLAN_DISCOUNT_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const PaymentPlanUpdateDiscountAction =
  (payload: any, params: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPDATE_PAYMENT_PLAN_DISCOUNT_REQUEST });

      let data = await PATCHAPI(
        ApiConfig?.PlanDiscountUpdate + params,
        payload,
        true
      );

      if (data && data.status === true) {
        dispatch({
          type: UPDATE_PAYMENT_PLAN_DISCOUNT_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: UPDATE_PAYMENT_PLAN_DISCOUNT_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const ManualCreditGrantAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_MANUAL_CREDIT_GRANT_REQUEST });
      let data = await POSTAPI(ApiConfig?.ManualCreditGrant, payload, false);
      if (data && data.status === true) {
        dispatch({
          type: CREATE_MANUAL_CREDIT_GRANT_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: CREATE_MANUAL_CREDIT_GRANT_FAIL,
          data: data || { status: false, message: "Request failed" },
        });
      }
    } catch (error) {}
  };

export const EntityTransactionsAction =
  (entityType: string, entityId: number, limit: number = 5) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_ENTITY_TRANSACTIONS_REQUEST });
      const url = `${ApiConfig?.EntityTransactions}?entity_type=${entityType}&entity_id=${entityId}&limit=${limit}`;
      let data = await GETAPI(url);
      if (data && data.status === true) {
        dispatch({
          type: GET_ENTITY_TRANSACTIONS_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_ENTITY_TRANSACTIONS_FAIL,
          data: [],
        });
      }
    } catch (error) {
      dispatch({
        type: GET_ENTITY_TRANSACTIONS_FAIL,
        data: [],
      });
    }
  };

